import { Grid} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import i18n from "../../lib/appfuse-react/core/i18n";
import React, {useEffect} from "react";
import Form from "../../lib/appfuse-react/component/Form";
import SelectField from "../../lib/appfuse-react/component/SelectField";
import lang from "../../lib/appfuse-react/core/lang";
import UserEvent from "../../lib/appfuse-react/core/UserEvent";
import {useDispatch, useSelector} from "../../store";
import {selectCounty, setCounty} from "../../reducer/util/utilReducer";
import utilService from "../../service/util/utilService";
import TextField from "../../lib/appfuse-react/component/TextField";

function AddressThreeColumn(props){
    const {subtitle, required = false, withTitle=true, readOnly} = props;
    const value = props.value || {};
    const counties = useSelector(selectCounty);
    const dispatch = useDispatch();
    const {towns=[]} = counties.find(item => item.code===value.county) || {};
    const variant = readOnly ? 'standard' : 'outlined';

    useEffect(() => {
        (async () => {
            if(lang.isEmpty(counties)) {
                dispatch(setCounty(await utilService.findAllCounties()));
            }
        })()
    }, [])

    const handleChange = ({value, change:{county, town}}) => {
        if(lang.isNotUndefined(county)) {
            value.town = null;
            value.zip = null;
        }
        if(lang.isNotUndefined(town)) {
            value.zip = towns.find(item => item.code===value.town)?.zip;
        }
        props.onChange(new UserEvent({value}));
    };

    return (
        <Form value={value} change={props.change} onChange={handleChange} readOnly={readOnly}>
            {withTitle &&
            <Typography variant="subtitle1" gutterBottom color="textSecondary">
                {i18n.translate(subtitle)}
            </Typography>
            }
            <Grid  container spacing={2}>
                <Grid item xs={4}>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <SelectField defaultFirst label={i18n.translate('Country')} code='country' variant={variant} name="country" required={required}/>
                        </Grid>
                        <Grid item xs={6}>
                            <SelectField label={i18n.translate('City')} options={counties} valueAccessor='code' textAccessor='name' variant={variant} name="county" required={required} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={4}>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <SelectField label={i18n.translate('District')} options={towns} name="town" valueAccessor='code' textAccessor='name' variant={variant} required={required}/>
                        </Grid>
                        <Grid item xs={6}>
                            <TextField name="zip" label={i18n.translate('Zip')} variant={variant} fullWidth required={required}/>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={4}>
                    <TextField name="street" label={i18n.translate('Street')} variant={variant} fullWidth required={required}/>
                </Grid>
            </Grid>
        </Form>
    )
}

export default AddressThreeColumn;